import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicInput, BaasicFieldDropdown, DatePickerField, BaasicFormControls, BaasicButton, BaasicModal } from 'core/components';
import { ApplicationEditLayout, Content, PageFooter } from 'core/layouts';
import { ExistingPatientDataModal } from 'application/facility-order/components';

function FacilityOrderTemplatePatientCreateTemplate({ facilityOrderTemplatePatientCreateViewStore, t }) {
    const {
        contentLoading,
        form,
        checkForExistingBrightreePatient,
        existingPatientDataModal,
        contactRelationshipStore,
        primaryInsuranceStore,
        secondaryInsuranceStore,
        rootStore,
        diagnosisCodesStore,
        doctorStore,
        genderStore,
        stateStore,
        oldPrimaryInsuranceStore,
        oldPrimaryInsuranceDisplayed,
        toggleOldPrimaryInsurance,
        invalidateInsurances,
        hasPermission,
        isDisabled,
        isCheckingForExistingPatient,
        subCategoryStore,
        capitalizeFirstLetter,
        reloadPatient
    } = facilityOrderTemplatePatientCreateViewStore;

    return (
        <ApplicationEditLayout store={facilityOrderTemplatePatientCreateViewStore}>
            <Content loading={contentLoading}>
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div className="row">
                                <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                    <h4 className="form__title">Personal Data</h4>
                                    <div className="row row--form">
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('firstName')} onBlur={capitalizeFirstLetter} disabled={!isDisabled()} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('lastName')} onBlur={capitalizeFirstLetter} disabled={!isDisabled()} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('dateOfBirth')} disabled={!isDisabled()} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            <BasicInput field={form.$('ssn')} />
                                        </div>
                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                            {isDisabled() ?
                                                <BaasicButton
                                                    className="btn btn--base btn--primary u-mar--right--sml"
                                                    label="Check For Existing"
                                                    onClick={() => { checkForExistingBrightreePatient() }}
                                                    icon={
                                                        isCheckingForExistingPatient
                                                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                                                            : 'u-display--none'
                                                    }
                                                    disabled={isCheckingForExistingPatient}
                                                /> :
                                                <BaasicButton
                                                    className="btn btn--base btn--primary u-mar--right--sml"
                                                    label="Check For Another"
                                                    onClick={() => { reloadPatient() }}
                                                    icon={ 'u-display--none' }
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                                {!isDisabled() &&
                                    <React.Fragment>
                                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                            <h4 className="form__title">Contact Data</h4>
                                            <div className="row">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('contactRelationship')} store={contactRelationshipStore} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('contactFirstName')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('contactLastName')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('contactAddressLine1')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('contactAddressLine2')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('contactCity')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('contactCountry')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('contactState')} store={stateStore} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('contactPostalCode')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('contactPhone')} disabled={isDisabled()} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                            <h4 className="form__title">Clinical Data</h4>
                                            <div className="row">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('gender')} store={genderStore} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('height')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('weight')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('diagnosisCodes')} store={diagnosisCodesStore} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('doc')} store={doctorStore} disabled={isDisabled()} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                            <div className="u-flex--primary form__title">
                                                <h4 className="form__title--secondary">Primary Insurance Information</h4>
                                                <BaasicButton className="btn btn--base btn--primary u-mar--left--tny u-flex--last"
                                                    label={'Refresh Insurances'}
                                                    icon="u-icon u-icon--sml u-icon--synchronize"
                                                    onClick={invalidateInsurances}
                                                    disabled={!hasPermission || isDisabled()}
                                                ></BaasicButton>
                                            </div>

                                            <div className="row">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('primaryInsuranceName')} store={primaryInsuranceStore} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('primaryInsurancePolicyNumber')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <DatePickerField field={form.$('primaryInsuranceStartDate')} disabled={isDisabled()} />
                                                </div>
                                            </div>
                                            <div className="card card--secondary">
                                                {oldPrimaryInsuranceDisplayed &&
                                                    <div className="row u-mar--bottom--sml">
                                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                            <BaasicFieldDropdown field={form.$('oldPrimaryInsuranceName')} store={oldPrimaryInsuranceStore} disabled={isDisabled()} />
                                                        </div>
                                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                            <BasicInput field={form.$('oldPrimaryInsurancePolicyNumber')} disabled={isDisabled()} />
                                                        </div>
                                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                            <DatePickerField field={form.$('oldPrimaryInsuranceStartDate')} disabled={isDisabled()} />
                                                        </div>
                                                        <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                            <DatePickerField field={form.$('oldPrimaryInsuranceEndDate')} disabled={isDisabled()} />
                                                        </div>
                                                    </div>
                                                }
                                                <BaasicButton
                                                    onClick={() => toggleOldPrimaryInsurance()}
                                                    className='btn btn--base btn--link'
                                                    icon={(oldPrimaryInsuranceDisplayed ? 'u-icon--remove' : 'u-icon--add') + ' u-icon u-icon--med u-align--v--7'}
                                                    label={(oldPrimaryInsuranceDisplayed ? 'Remove' : 'Add') + ' Old Primary Insurance'}
                                                    disabled={!hasPermission || isDisabled()}
                                                />
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                            <h4 className="form__title">Secondary Insurance Information</h4>
                                            <div className="row">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('secondaryInsuranceName')} store={secondaryInsuranceStore} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BasicInput field={form.$('secondaryInsurancePolicyNumber')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <DatePickerField field={form.$('secondaryInsuranceStartDate')} disabled={isDisabled()} />
                                                </div>
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <DatePickerField field={form.$('secondaryInsuranceEndDate')} disabled={isDisabled()} />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col col-sml-12 col-lrg-12 u-mar--bottom--med">
                                            <h4 className="form__title">Sub Category</h4>
                                            <div className="row">
                                                <div className="form__group col col-lrg-4 u-mar--bottom--sml">
                                                    <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} disabled={isDisabled()} />
                                                </div>
                                            </div>
                                        </div>
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
            <PageFooter>
                {!isDisabled() && <BaasicFormControls form={form} onSubmit={form.onSubmit} authorized={hasPermission} disabled={isDisabled()} />}
                <BaasicButton
                    className='btn btn--base btn--ghost'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => rootStore.routerStore.goBack()}
                    icon='u-icon u-icon--xsml u-icon--btn-back'
                />
            </PageFooter>
            <BaasicModal modalParams={existingPatientDataModal} className="modal__content modal--med">
                <ExistingPatientDataModal />
            </BaasicModal>
        </ApplicationEditLayout>
    )
}

FacilityOrderTemplatePatientCreateTemplate.propTypes = {
    facilityOrderTemplatePatientCreateViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplatePatientCreateTemplate);
